/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { StadiaLatLng, StadiaMarkerIcon } from '../stadia-maps.types';
import { StadiaMapsContextService } from '../stadia-maps-context.service';
import maplibregl from 'maplibre-gl';

@Component({
    selector: 'pxw-stadia-maps-marker',
    imports: [CommonModule],
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StadiaMapsMarkerComponent implements OnInit, OnDestroy {
  private stadiaMapsContext = inject(StadiaMapsContextService);

  lat = input.required<number>();
  lng = input.required<number>();
  draggable = input<boolean>(false);
  icon = input<StadiaMarkerIcon | null>(null);

  markerDragEnd = output<StadiaLatLng>();

  protected markerInstance: maplibregl.Marker;
  protected dragOffset: { x: number; y: number };

  constructor() {
    effect(() => {
      if (this.markerInstance && this.lat() && this.lng()) {
        this.markerInstance.setLngLat({
          lat: this.lat(),
          lng: this.lng(),
        });
      }
    });
  }

  ngOnInit(): void {
    this.markerInstance = new maplibregl.Marker({ draggable: this.draggable() }).setLngLat({
      lat: this.lat(),
      lng: this.lng(),
    });

    const icon = this.icon();

    if (icon) {
      const el = document.createElement('img');
      el.src = icon.url;
      el.style.width = `${icon.width}px`;
      el.style.height = `${icon.height}px`;
      el.style.cursor = 'pointer';

      this.markerInstance.getElement().innerHTML = '';
      this.markerInstance.getElement().appendChild(el);
    }

    if (this.draggable()) {
      this.markerInstance.on('dragend', () => {
        this.markerDragEnd.emit(this.markerInstance.getLngLat());
      });
    }

    this.markerInstance.addTo(this.stadiaMapsContext.mapInstance);
  }

  ngOnDestroy(): void {
    this.markerInstance.remove();
  }
}
